import { FC, memo } from 'react';

import V2DriversPresenter from './V2DriversPresenter';

const V2Drivers: FC = memo(() => (
  <V2DriversPresenter />
));

export default V2Drivers;
